import { groupBy } from 'ramda';

export function extractPhotosByTags(photos, tags) {
  const groupedPhotosByTag = groupBy(
    (photo) => {
      const tagName = tags.find((tag) => photo.full_path.includes(tag));
      return tagName;
    },
    photos.filter((photo) => tags.some((tag) => photo.full_path.includes(tag)))
  );
  return Object.keys(groupedPhotosByTag).reduce((acc, tag) => acc.concat(...groupedPhotosByTag[tag]), []);
}

export function allTagsHaveAPhoto(photos, tags) {
  if (tags.length === 0) return false;
  return tags.every((tag) => photos.some((photo) => photo.full_path.includes(tag)));
}

export function isEnabledCreateStoryFeature(opts) {
  return Object.keys(opts || {}).length > 0 && opts.storiesPrintPool.length > 0;
}

export function isCreatedAStory(photos, finishTag) {
  return photos.some((photo) => photo.full_path.includes(finishTag));
}

export function isExpiredDoubleClickDelay(delay, lastTime) {
  if (lastTime === 0) return true;
  return Date.now() - lastTime > delay;
}

export function saveLastTime(lastTimeMs) {
  localStorage.setItem('lastTime', lastTimeMs);
}

export function getLastTime() {
  return Number(localStorage.getItem('lastTime') || 0);
}
